import React from "react";
import { Grid, Typography, Divider } from "@mui/material";

const OfficeLocation: React.FC = () => {
  return (
    <Grid container spacing={2} sx={{ padding: { xs: 2, md: 5 } }}>
      {/* Left Side: Office Addresses */}
      <Grid item xs={12} md={6}>
        <Typography variant="h5" gutterBottom color={"#172554"} className='component'>
          Head Office
        </Typography>
        <Typography variant="body1" color={"black"} className='component'>
          3rd Floor, Pillars Gate,<br /> Vadasery, Kanyakumari Dist., <br />TamilNadu - 629001.
        </Typography>
        <Typography variant="body1" color="black" className='component'>Contact: +91 7305197833</Typography>
        <Typography variant="body1" color="black" className='component'>Email: matt@mattengg.com</Typography>
        <Divider sx={{ marginBottom: 3, marginTop: 3 }} />

        <Typography variant="h5" gutterBottom color={"#172554"} className='component'>
          Branch Office
        </Typography>
        <Typography variant="body1" color={"black"} className='component'>
          1st Floor, Quality Bakers,<br /> HMT Junction, Kalamassery,<br /> Ernakulam - 683104.
        </Typography>
        <Typography variant="body1" color="black" className='component'>Contact: +91 9486178103</Typography>
        <Typography variant="body1" color="black" className='component'>Email: matt@mattengg.com</Typography>
      </Grid>

      {/* Right Side: Map */}
      <Grid item xs={12} md={6} className='component'>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3949.13972942604!2d77.42837677477046!3d8.188676291842896!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b079f1ee9751ff9%3A0x52576268e02d8822!2sMatt%20Engineering%20Solutions!5e0!3m2!1sen!2sin!4v1696231543460!5m2!1sen!2sin"
          width="100%"
          height="350"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
        />
      </Grid>
    </Grid>
  );
};

export default OfficeLocation;
